<script>
  import ArtworkPreview from "./ArtworkPreview.svelte";
  import Button from "./Button.svelte";
  // import ExternalLink from "./ExternalLink.svelte";
  import LinkButton from "./LinkButton.svelte";
  // import StaticArtwork from "./StaticArtwork.svelte";
  // import Video from "./Video.svelte";
  // import flowchart from "../assets/flowchart.png";
  import { getContext, onMount } from "svelte";
  import VideoEmbed from "./VideoEmbed.svelte";
  import LatestMints from "./LatestMints.svelte";
  import Footer from "./Footer.svelte";
  import {
    ETH_PRICE,
    IS_PRE_LAUNCH,
    isAfterLaunchStore,
    isBeforeLaunchStore,
    LINK_ABOUT,
    LINK_CREATE,
    LINK_EDITIONS,
    LINK_GALLERY,
    SALE_END_DATE,
    SALE_START_DATE,
  } from "../util/constants";
  import EditionsTextBlock from "./EditionsTextBlock.svelte";
  // import EditionsGallery from "./EditionsGallery.svelte";
  import EditionsZoomPreview from "./EditionsZoomPreview.svelte";
  // import StaticPunchedCard from "./StaticPunchedCard.svelte";
  import PunchCardInfo from "./PunchCardInfo.svelte";
  import Paragraph from "./Paragraph.svelte";
  import BulletInfo from "./BulletInfo.svelte";
  import Anchor from "./Anchor.svelte";
  import RoundLinkButton from "./RoundLinkButton.svelte";
  import InterviewContainer from "./InterviewContainer.svelte";
  import { createAnchorScroller } from "../util/anchor-link";
  import EpisodeEmbed from "./EpisodeEmbed.svelte";
  // import MainWrapper from "./MainWrapper.svelte";
  const encodingStore = getContext("encoding");

  let canvasWidth = "100%";
  let punchCardBreakpoint = 900;
  let innerWidth = window.innerWidth;
  const cardClickable = false;

  onMount(() => {
    const unsub = createAnchorScroller();
    return () => {
      unsub();
    };
  });

  function canvasResized(ev) {
    const { width, height } = ev.detail;
    canvasWidth = `${width}px`;
    // console.log('canvas', width)
  }

  function windowResized(ev) {
    innerWidth = window.innerWidth;
  }
</script>

<svelte:window on:resize|passive={windowResized} />
<main>
  <section class="section intro noborder maxwidth">
    <div class="column-small intro">
      <BulletInfo />
      {#if innerWidth >= punchCardBreakpoint}
        <PunchCardInfo
          marginTop
          on:randomize
          clickable={cardClickable}
          {canvasWidth}
        />
      {/if}
    </div>
    <div class="column-big intro">
      <div class="artwork-preview">
        <ArtworkPreview allowMint on:randomize on:resized={canvasResized} />
        {#if innerWidth < punchCardBreakpoint}
          <PunchCardInfo
            on:randomize
            marginTop
            clickable={cardClickable}
            reverseCaption
            {canvasWidth}
            forceCanvasWidth
          />
        {/if}
      </div>
    </div>
  </section>

  <section class="section read-more noborder maxwidth">
    <div class="button-container">
      <RoundLinkButton bigger text="READ MORE" href={`/${LINK_ABOUT}`}
      ></RoundLinkButton>
      {#if $isAfterLaunchStore}
        <RoundLinkButton bigger text="VIEW GALLERY" href={`/${LINK_GALLERY}`}
        ></RoundLinkButton>
      {:else}
        <RoundLinkButton bigger text="EDIT DESIGN" href={`/${LINK_CREATE}`}
        ></RoundLinkButton>
      {/if}
    </div>
  </section>

  <section class="section editions">
    <Anchor id="edition" />
    <div class="column-small editions">
      <EditionsTextBlock>
        <Paragraph>
          The 32 Bit Edition is a limited collection of 32 tokens, initially
          curated by the artist, that runs alongside the crowdfund. It will be
          distributed in two ways: the first 16 tokens will be given to users of
          the system through a weekly random raffle; the remaining 16 will be
          given to the crowdfund's top contributors (by total ETH donated).
          These limited 32 works have a distinct palette and on-chain logic,
          allowing owners to change their designs indefinitely, even after the
          crowdfund closes.
          <!-- Alongside the open edition crowdfund, there is a separate collection
          of 32 limited-edition tokens curated by the artist that will be
          distributed over four weeks. Of these, the first 16 will be awarded
          through a weekly random raffle. If you've minted one or more tokens,
          your address will automatically be entered into that week's raffle.
          The remaining 16 tokens will be reserved for the project's top
          contributors after the crowdfund concludes, based on a ranking of
          total ETH contributed. -->

          <!-- In addition to the open edition crowdfund, there is a set of 32
          limited-edition tokens that will be distributed over four weeks. Of
          these, 16 will be distributed via a weekly random raffle, and the
          remaining 16 will be distributed to the project's top contributors
          once the crowdfund finishes. If your address has minted one or more
          tokens, it will be automatically entered into that week's raffle. -->
        </Paragraph>
        <Paragraph>
          See the <LinkButton to={`/${LINK_EDITIONS}`}>EDITIONS</LinkButton> page
          for more details.
        </Paragraph>
      </EditionsTextBlock>
    </div>
    <div class="column-big editions">
      <EditionsZoomPreview />
    </div>
  </section>

  <section class="section media maxwidth">
    <!-- <div class="header noselect">About</div>
  <div class="read-more">
    <Paragraph>
      Watch the video below to learn more, or visit the <LinkButton
        upper
        to={`/${LINK_ABOUT}`}>About</LinkButton
      > page for further details.
    </Paragraph>
  </div> -->
    <div class="column-big media">
      <VideoEmbed aspectRatio="1920/1080" />
    </div>
    <div class="column-small media">
      <div class="caption">↗ A brief introduction by the artist.</div>
    </div>
  </section>

  <section class="section interview maxwidth">
    <div class="header">In Conversation</div>
    <EpisodeEmbed></EpisodeEmbed>
  </section>

  {#if !$isBeforeLaunchStore}
    <section class="section latest noborder maxwidth">
      <div class="header">Latest Mints</div>
      <LatestMints></LatestMints>
    </section>
  {/if}
</main>

<Footer></Footer>

<!-- <section class="section punch">
  <div class="info">
    Bitframes is a celebration of the constraints of the mainframe computing
    era. The 32 bytes of data can neatly fit on a punched card, to construct
    each frame of a serial artwork. Changing even one bit—or a single hole
    punch—leads to an entirely different composition. Despite this constraint,
    the system is capable of millions of possibilities.
  </div>
  <div class="card">
    <StaticPunchedCard background="black" encoding={$encodingStore} />
  </div>
</section> -->

<style>
  main {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    /* max-width: 1600px; */
  }
  .section {
    --border-color: black;
    width: 100%;
    /* max-width: 1000px; */
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    padding: var(--main-gutter);
    padding-top: var(--main-gutter-vertical);
    padding-bottom: var(--main-gutter-vertical);
    flex-direction: column;
    /* flex-grow: 1; */
    /* flex-shrink: 1; */
    border-bottom: 1px solid var(--border-color);
  }
  .section {
    display: flex;
    flex-direction: row;
    /* flex-basis: 80vh; */
  }
  .caption {
    margin-top: 10px;
    font-size: 12px;
  }
  .column-small,
  .column-big {
    display: flex;
    flex-grow: 1;
    flex-shrink: 1;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }
  .column-small {
    padding-right: var(--main-gutter);
  }
  .column-big.intro {
    align-items: flex-end;
    justify-content: flex-end;
  }
  .section.latest {
    flex-direction: column;
  }
  .read-more {
    display: flex;
    justify-content: center;
    align-items: center;
    max-width: 100%;
    /* min-height: 160px; */
    /* margin-bottom: 20px; */
    /* min-height: 250px; */
    /* border-top: 1px solid black; */
    /* background: red; */
  }
  .button-container {
    display: flex;
    /* justify-content: space-evenly; */
    justify-content: center;
    width: 100%;
    /* max-width: 650px; */
    gap: 20px;
  }
  .column-big {
    /* max-height: 350px; */
    /* flex-basis: 30vmin; */
    flex-basis: 50%;
  }
  .column-small {
    flex-basis: 50%;
  }

  .section.editions {
    border-bottom: 0;
    background: hsla(0, 0%, 0%, 1);
    color: white;
    /* max-height: 80vh; */
    overflow: hidden;
    display: flex;
    justify-content: center;
    padding: 0px;
    margin-top: 20px;
    /* margin-bottom: 20px; */
  }
  .column-small.editions {
    max-width: calc(var(--max-width) / 2);
    flex-grow: 1;
    flex-shrink: 1;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 0px;
    flex-basis: 50%;
    min-width: 400px;
    /* min-width: calc(min(100vw, 250px)); */
    padding-left: var(--main-gutter);
    padding-right: var(--main-gutter);
    padding-top: var(--main-gutter);
    padding-bottom: var(--main-gutter);
    /* padding-right: 0px; */
  }
  .column-big.editions {
    max-width: calc(var(--max-width) / 2);
    flex-basis: 50%;
    flex-grow: 1;
    flex-shrink: 1;
    box-sizing: border-box;

    /* aspect-ratio: 1; */
    min-height: 128px;
    /* min-height: calc(max(300px, min(50vh, 500px))); */

    /* margin-left: 20px; */
    /* padding: 10px; */
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 0px;
  }
  .header {
    /* font-weight: bold; */
    /* text-transform: uppercase; */
    line-height: 1;
    margin-top: 0px;
    margin-bottom: 20px;
    /* font-size: 16px; */
    font-size: 25px;
    padding-bottom: 0;
  }
  .section.media {
    flex-direction: column;
    border-bottom: 0;
    margin-top: 20px;
  }
  .section.interview {
    flex-direction: column;
    border-bottom: 0;
    /* margin-bottom: 20px; */
    /* margin-top: 20px; */
  }
  .noborder {
    border-bottom: 0;
  }
  .column-small.media {
    flex-basis: initial;
    flex-grow: 1;
    flex-shrink: 1;
    padding-left: 0;
    /* padding-left: var(--main-gutter); */
  }
  .column-big.media {
    flex-basis: 100%;
    width: 100%;
    flex-grow: 1;
    flex-shrink: 1;
  }
  @media screen and (max-width: 720px) {
    .column-small.intro {
      padding-right: 0px;
    }
    .section.editions {
      max-height: initial;
      /* margin-bottom: 20px; */
      /* margin-top: 20px; */
      /* padding: 40px; */
      /* padding-top: 60px; */

      /* margin: 0; */
      /* padding: 0; */
    }
    .column-big.media {
      margin-right: 0px;
      /* padding-top: 20px; */
    }
    .section {
      --border-color: transparent;
      flex-direction: column;
    }
    .column-small {
      margin-left: 0;
      margin-right: 0;
    }
    .column-big {
      margin-top: var(--main-gutter);
      margin-left: 0;
      margin-right: 0;
      align-items: flex-start;
      flex-basis: initial;
    }
    .column-small.editions {
      min-width: initial;
      margin-bottom: 20px;
      /* padding: 40px; */

      /* padding-right: 0; */
    }
    .column-big.editions {
      margin-left: 0;
      margin-top: 0px;
      margin-bottom: 0px;
      padding: 0;
      min-height: 40vh;

      /* height: 50vh; */
      /* min-height: calc(max(300px, min(50vh, 500px))); */

      /* border-bottom: 20px solid black; */
    }
    .column-big.media {
      margin-bottom: 0px;
      margin-top: 0px;
      padding-top: 0;
    }
  }
</style>
